import Colors from "../../constants/Colors";
import { useTranslation } from 'react-i18next';

const SuccessCasesCardNew = ({ color = Colors.blue }) => {
    const { t } = useTranslation();

    const SuccessCasesData = t('cases.list');
    return (
        <div className="container pt-5">
            <h1 className="success-cases-title text-center fs-48 fw-semibold mb-5" style={{ color: color }} >
                {t('cases.title')}
            </h1>
            <div className="d-flex flex-column align-items-center">
                {
                    SuccessCasesData.map((item, index) => {
                        return (
                            <div key={index} className="success-cases-card py-4 px-3 px-md-5 my-5 mx-3 d-flex flex-column bg-white">
                                <p className="success-cases-description fw-bold mt-4">{item.title}</p>
                                <img className="succes-cases-img py-4 mx-auto" alt='' src={(`${process.env.PUBLIC_URL}/images/cases/${item.imgURL}`)} />
                                <div className="">
                                    <p className="success-cases-description">{item.description}</p>
                                    <ul>
                                        {item.list.map((item, index) => {
                                            return (
                                                <li key={index} className="fs-14">
                                                    {item.text}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    )
}

export default SuccessCasesCardNew